import { render } from "./contentTabs.vue?vue&type=template&id=1dfa02ad"
import script from "./contentTabs.vue?vue&type=script&lang=js"
export * from "./contentTabs.vue?vue&type=script&lang=js"

import "./contentTabs.vue?vue&type=style&index=0&id=1dfa02ad&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__